/* eslint-disable */
// @ts-nocheck

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestId, deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserId, deleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenId, deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestId, deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserId, deleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuId, deleteApiV1WeddingsByWeddingIdAdminRichmenusDefault, deleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserId, deleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId, deleteApiV1WeddingsByWeddingIdAdminStaffByUserId, deleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationId, deleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableId, getApiV1MeOrganizations, getApiV1MeWeddings, getApiV1OrganizationsByOrganizationId, getApiV1OrganizationsByOrganizationIdMembers, getApiV1OrganizationsByOrganizationIdWeddings, getApiV1StaffInvitationsByToken, getApiV1WeddingsByWeddingId, getApiV1WeddingsByWeddingIdActivitiesBlessings, getApiV1WeddingsByWeddingIdActivitiesRandomNumberState, getApiV1WeddingsByWeddingIdAdminActivitiesAngpao, getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState, getApiV1WeddingsByWeddingIdAdminActivitiesSessions, getApiV1WeddingsByWeddingIdAdminActivitiesWall, getApiV1WeddingsByWeddingIdAdminCheckins, getApiV1WeddingsByWeddingIdAdminDisplayTokens, getApiV1WeddingsByWeddingIdAdminGuests, getApiV1WeddingsByWeddingIdAdminGuestsByGuestId, getApiV1WeddingsByWeddingIdAdminLineChannel, getApiV1WeddingsByWeddingIdAdminLineUsers, getApiV1WeddingsByWeddingIdAdminRichmenus, getApiV1WeddingsByWeddingIdAdminRichmenusByMenuId, getApiV1WeddingsByWeddingIdAdminRichmenusSets, getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId, getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserId, getApiV1WeddingsByWeddingIdAdminRsvps, getApiV1WeddingsByWeddingIdAdminSettings, getApiV1WeddingsByWeddingIdAdminStaff, getApiV1WeddingsByWeddingIdAdminStaffInvitations, getApiV1WeddingsByWeddingIdAdminTablesAssignments, getApiV1WeddingsByWeddingIdAuthMe, getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumber, getApiV1WeddingsByWeddingIdDisplayActivitiesWall, getApiV1WeddingsByWeddingIdDisplayAttendees, getApiV1WeddingsByWeddingIdDisplayGuests, getApiV1WeddingsByWeddingIdGuests, getApiV1WeddingsByWeddingIdGuestsByGuestId, getApiV1WeddingsByWeddingIdGuestsGroups, getApiV1WeddingsByWeddingIdRsvpsTokenInfo, getApiV1WeddingsByWeddingIdSettings, getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignment, getApiV1WeddingsByWeddingIdTablesMaster, getApiV1WeddingsByWeddingIdTablesMasterAll, getApiV1WeddingsByWeddingIdTablesMasterByTableId, getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuests, getHealthz, type Options, patchApiV1WeddingsByWeddingIdAdminGuestsByGuestId, patchApiV1WeddingsByWeddingIdAdminLineChannel, patchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId, patchApiV1WeddingsByWeddingIdAdminSettings, patchApiV1WeddingsByWeddingIdAdminTablesMasterByTableId, postApiV1AuthLineToken, postApiV1LineWebhook, postApiV1Organizations, postApiV1StaffInvitationsByTokenAccept, postApiV1Weddings, postApiV1WeddingsByWeddingIdActivitiesAngpao, postApiV1WeddingsByWeddingIdActivitiesBlessings, postApiV1WeddingsByWeddingIdActivitiesRandomNumberDraw, postApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberReset, postApiV1WeddingsByWeddingIdAdminActivitiesWallBackground, postApiV1WeddingsByWeddingIdAdminCheckinsManual, postApiV1WeddingsByWeddingIdAdminDisplayTokens, postApiV1WeddingsByWeddingIdAdminGuests, postApiV1WeddingsByWeddingIdAdminGuestsBatch, postApiV1WeddingsByWeddingIdAdminGuestsBulkDelete, postApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIds, postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledge, postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsers, postApiV1WeddingsByWeddingIdAdminGuestsImport, postApiV1WeddingsByWeddingIdAdminGuestsParseImport, postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessaging, postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniapp, postApiV1WeddingsByWeddingIdAdminLineChannelVerifySession, postApiV1WeddingsByWeddingIdAdminRichmenus, postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefault, postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImage, postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserId, postApiV1WeddingsByWeddingIdAdminRichmenusSets, postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicate, postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImage, postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublish, postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidate, postApiV1WeddingsByWeddingIdAdminRichmenusSyncAll, postApiV1WeddingsByWeddingIdAdminStaffInvitations, postApiV1WeddingsByWeddingIdAdminTablesAssign, postApiV1WeddingsByWeddingIdAdminTablesBulk, postApiV1WeddingsByWeddingIdAdminTablesMaster, postApiV1WeddingsByWeddingIdAdminTablesMasterImport, postApiV1WeddingsByWeddingIdAdminTablesSyncAssignments, postApiV1WeddingsByWeddingIdAdminTablesSyncSeats, postApiV1WeddingsByWeddingIdAdminTablesUnassign, postApiV1WeddingsByWeddingIdCheckins, postApiV1WeddingsByWeddingIdLineChannelVerifyProviderPing, postApiV1WeddingsByWeddingIdRsvps, postApiV1WeddingsByWeddingIdRsvpsPublic, postInternalV1OrganizationsByOrganizationIdMembers, putApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState, putApiV1WeddingsByWeddingIdAdminActivitiesWall, putApiV1WeddingsByWeddingIdAdminStaffByUserId, putApiV1WeddingsByWeddingIdAdminTablesMasterLayout } from '../sdk.gen';
import type { DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdError, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdError, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdError, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdError, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdError, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultError, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdError, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdError, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdError, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdResponse, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, GetApiV1MeOrganizationsData, GetApiV1MeOrganizationsError, GetApiV1MeOrganizationsResponse, GetApiV1MeWeddingsData, GetApiV1MeWeddingsError, GetApiV1MeWeddingsResponse, GetApiV1OrganizationsByOrganizationIdData, GetApiV1OrganizationsByOrganizationIdError, GetApiV1OrganizationsByOrganizationIdMembersData, GetApiV1OrganizationsByOrganizationIdMembersError, GetApiV1OrganizationsByOrganizationIdMembersResponse, GetApiV1OrganizationsByOrganizationIdResponse, GetApiV1OrganizationsByOrganizationIdWeddingsData, GetApiV1OrganizationsByOrganizationIdWeddingsError, GetApiV1OrganizationsByOrganizationIdWeddingsResponse, GetApiV1StaffInvitationsByTokenData, GetApiV1StaffInvitationsByTokenError, GetApiV1StaffInvitationsByTokenResponse, GetApiV1WeddingsByWeddingIdActivitiesBlessingsData, GetApiV1WeddingsByWeddingIdActivitiesBlessingsError, GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateData, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateError, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoError, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateError, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsError, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesWallData, GetApiV1WeddingsByWeddingIdAdminActivitiesWallError, GetApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, GetApiV1WeddingsByWeddingIdAdminCheckinsData, GetApiV1WeddingsByWeddingIdAdminCheckinsError, GetApiV1WeddingsByWeddingIdAdminCheckinsResponse, GetApiV1WeddingsByWeddingIdAdminDisplayTokensData, GetApiV1WeddingsByWeddingIdAdminDisplayTokensError, GetApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, GetApiV1WeddingsByWeddingIdAdminGuestsData, GetApiV1WeddingsByWeddingIdAdminGuestsError, GetApiV1WeddingsByWeddingIdAdminGuestsResponse, GetApiV1WeddingsByWeddingIdAdminLineChannelData, GetApiV1WeddingsByWeddingIdAdminLineChannelError, GetApiV1WeddingsByWeddingIdAdminLineChannelResponse, GetApiV1WeddingsByWeddingIdAdminLineUsersData, GetApiV1WeddingsByWeddingIdAdminLineUsersError, GetApiV1WeddingsByWeddingIdAdminLineUsersResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdError, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusData, GetApiV1WeddingsByWeddingIdAdminRichmenusError, GetApiV1WeddingsByWeddingIdAdminRichmenusResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdError, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdResponse, GetApiV1WeddingsByWeddingIdAdminRsvpsData, GetApiV1WeddingsByWeddingIdAdminRsvpsError, GetApiV1WeddingsByWeddingIdAdminRsvpsResponse, GetApiV1WeddingsByWeddingIdAdminSettingsData, GetApiV1WeddingsByWeddingIdAdminSettingsError, GetApiV1WeddingsByWeddingIdAdminSettingsResponse, GetApiV1WeddingsByWeddingIdAdminStaffData, GetApiV1WeddingsByWeddingIdAdminStaffError, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsData, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsError, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, GetApiV1WeddingsByWeddingIdAdminStaffResponse, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsError, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponse, GetApiV1WeddingsByWeddingIdAuthMeData, GetApiV1WeddingsByWeddingIdAuthMeError, GetApiV1WeddingsByWeddingIdAuthMeResponse, GetApiV1WeddingsByWeddingIdData, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberData, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberError, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberResponse, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallData, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallError, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallResponse, GetApiV1WeddingsByWeddingIdDisplayAttendeesData, GetApiV1WeddingsByWeddingIdDisplayAttendeesError, GetApiV1WeddingsByWeddingIdDisplayAttendeesResponse, GetApiV1WeddingsByWeddingIdDisplayGuestsData, GetApiV1WeddingsByWeddingIdDisplayGuestsError, GetApiV1WeddingsByWeddingIdDisplayGuestsResponse, GetApiV1WeddingsByWeddingIdError, GetApiV1WeddingsByWeddingIdGuestsByGuestIdData, GetApiV1WeddingsByWeddingIdGuestsByGuestIdError, GetApiV1WeddingsByWeddingIdGuestsByGuestIdResponse, GetApiV1WeddingsByWeddingIdGuestsData, GetApiV1WeddingsByWeddingIdGuestsError, GetApiV1WeddingsByWeddingIdGuestsGroupsData, GetApiV1WeddingsByWeddingIdGuestsGroupsError, GetApiV1WeddingsByWeddingIdGuestsGroupsResponse, GetApiV1WeddingsByWeddingIdGuestsResponse, GetApiV1WeddingsByWeddingIdResponse, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoData, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoError, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoResponse, GetApiV1WeddingsByWeddingIdSettingsData, GetApiV1WeddingsByWeddingIdSettingsError, GetApiV1WeddingsByWeddingIdSettingsResponse, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentData, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentError, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentResponse, GetApiV1WeddingsByWeddingIdTablesMasterAllData, GetApiV1WeddingsByWeddingIdTablesMasterAllError, GetApiV1WeddingsByWeddingIdTablesMasterAllResponse, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdData, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdError, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsData, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsError, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsResponse, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdResponse, GetApiV1WeddingsByWeddingIdTablesMasterData, GetApiV1WeddingsByWeddingIdTablesMasterError, GetApiV1WeddingsByWeddingIdTablesMasterResponse, GetHealthzData, GetHealthzResponse, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, PatchApiV1WeddingsByWeddingIdAdminLineChannelData, PatchApiV1WeddingsByWeddingIdAdminLineChannelError, PatchApiV1WeddingsByWeddingIdAdminLineChannelResponse, PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, PatchApiV1WeddingsByWeddingIdAdminSettingsData, PatchApiV1WeddingsByWeddingIdAdminSettingsError, PatchApiV1WeddingsByWeddingIdAdminSettingsResponse, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, PostApiV1AuthLineTokenData, PostApiV1AuthLineTokenError, PostApiV1AuthLineTokenResponse, PostApiV1LineWebhookData, PostApiV1LineWebhookError, PostApiV1LineWebhookResponse, PostApiV1OrganizationsData, PostApiV1OrganizationsError, PostApiV1OrganizationsResponse, PostApiV1StaffInvitationsByTokenAcceptData, PostApiV1StaffInvitationsByTokenAcceptError, PostApiV1StaffInvitationsByTokenAcceptResponse, PostApiV1WeddingsByWeddingIdActivitiesAngpaoData, PostApiV1WeddingsByWeddingIdActivitiesAngpaoError, PostApiV1WeddingsByWeddingIdActivitiesAngpaoResponse, PostApiV1WeddingsByWeddingIdActivitiesBlessingsData, PostApiV1WeddingsByWeddingIdActivitiesBlessingsError, PostApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawError, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetError, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundError, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundResponse, PostApiV1WeddingsByWeddingIdAdminCheckinsManualData, PostApiV1WeddingsByWeddingIdAdminCheckinsManualError, PostApiV1WeddingsByWeddingIdAdminCheckinsManualResponse, PostApiV1WeddingsByWeddingIdAdminDisplayTokensData, PostApiV1WeddingsByWeddingIdAdminDisplayTokensError, PostApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBatchData, PostApiV1WeddingsByWeddingIdAdminGuestsBatchError, PostApiV1WeddingsByWeddingIdAdminGuestsBatchResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteError, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsError, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeError, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersError, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersResponse, PostApiV1WeddingsByWeddingIdAdminGuestsData, PostApiV1WeddingsByWeddingIdAdminGuestsError, PostApiV1WeddingsByWeddingIdAdminGuestsImportData, PostApiV1WeddingsByWeddingIdAdminGuestsImportError, PostApiV1WeddingsByWeddingIdAdminGuestsImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportError, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingError, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappError, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionError, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultError, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageError, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdError, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusData, PostApiV1WeddingsByWeddingIdAdminRichmenusError, PostApiV1WeddingsByWeddingIdAdminRichmenusResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllError, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllResponse, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsError, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, PostApiV1WeddingsByWeddingIdAdminTablesAssignData, PostApiV1WeddingsByWeddingIdAdminTablesAssignError, PostApiV1WeddingsByWeddingIdAdminTablesAssignResponse, PostApiV1WeddingsByWeddingIdAdminTablesBulkData, PostApiV1WeddingsByWeddingIdAdminTablesBulkError, PostApiV1WeddingsByWeddingIdAdminTablesBulkResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterData, PostApiV1WeddingsByWeddingIdAdminTablesMasterError, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportError, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsError, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsError, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsResponse, PostApiV1WeddingsByWeddingIdAdminTablesUnassignData, PostApiV1WeddingsByWeddingIdAdminTablesUnassignError, PostApiV1WeddingsByWeddingIdAdminTablesUnassignResponse, PostApiV1WeddingsByWeddingIdCheckinsData, PostApiV1WeddingsByWeddingIdCheckinsError, PostApiV1WeddingsByWeddingIdCheckinsResponse, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingError, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingResponse, PostApiV1WeddingsByWeddingIdRsvpsData, PostApiV1WeddingsByWeddingIdRsvpsError, PostApiV1WeddingsByWeddingIdRsvpsPublicData, PostApiV1WeddingsByWeddingIdRsvpsPublicError, PostApiV1WeddingsByWeddingIdRsvpsPublicResponse, PostApiV1WeddingsByWeddingIdRsvpsResponse, PostApiV1WeddingsData, PostApiV1WeddingsError, PostApiV1WeddingsResponse, PostInternalV1OrganizationsByOrganizationIdMembersData, PostInternalV1OrganizationsByOrganizationIdMembersError, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateError, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, PutApiV1WeddingsByWeddingIdAdminActivitiesWallData, PutApiV1WeddingsByWeddingIdAdminActivitiesWallError, PutApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdError, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutError, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutResponse } from '../types.gen';

/**
 * Exchange a LINE access token for an internal API JWT token
 *
 * Verifies the LIFF-issued LINE Login access token (including channel match), syncs the LINE profile, and mints an internal API JWT token with {eventId, role} claims.
 */
export const postApiV1AuthLineTokenMutation = (options?: Partial<Options<PostApiV1AuthLineTokenData>>): UseMutationOptions<PostApiV1AuthLineTokenResponse, PostApiV1AuthLineTokenError, Options<PostApiV1AuthLineTokenData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthLineTokenResponse, PostApiV1AuthLineTokenError, Options<PostApiV1AuthLineTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1AuthLineToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * LINE Messaging webhook callback
 *
 * Receives LINE platform events for the configured wedding (LINE_DESTINATION_WEDDING_ID). Authenticated by the x-line-signature HMAC over the raw body, not a bearer token. Events are acked immediately and processed asynchronously; retried deliveries dedupe on webhookEventId.
 */
export const postApiV1LineWebhookMutation = (options?: Partial<Options<PostApiV1LineWebhookData>>): UseMutationOptions<PostApiV1LineWebhookResponse, PostApiV1LineWebhookError, Options<PostApiV1LineWebhookData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1LineWebhookResponse, PostApiV1LineWebhookError, Options<PostApiV1LineWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1LineWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiV1MeOrganizationsQueryKey = (options?: Options<GetApiV1MeOrganizationsData>) => createQueryKey('getApiV1MeOrganizations', options);

/**
 * List the organizations the caller belongs to
 *
 * Membership discovery for the admin app's organization picker. Never 404s — an empty list just means no memberships (shouldn't happen once every wedding has an auto-bootstrapped organization).
 */
export const getApiV1MeOrganizationsOptions = (options?: Options<GetApiV1MeOrganizationsData>) => queryOptions<GetApiV1MeOrganizationsResponse, GetApiV1MeOrganizationsError, GetApiV1MeOrganizationsResponse, ReturnType<typeof getApiV1MeOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1MeOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1MeOrganizationsQueryKey(options)
});

export const getApiV1MeWeddingsQueryKey = (options?: Options<GetApiV1MeWeddingsData>) => createQueryKey('getApiV1MeWeddings', options);

/**
 * List every wedding the caller can access
 *
 * The admin app's unified home-page list — every wedding reachable through organization membership, plus every wedding reachable only through a WeddingStaff invitation. Never 404s — an empty list just means no accessible weddings.
 */
export const getApiV1MeWeddingsOptions = (options?: Options<GetApiV1MeWeddingsData>) => queryOptions<GetApiV1MeWeddingsResponse, GetApiV1MeWeddingsError, GetApiV1MeWeddingsResponse, ReturnType<typeof getApiV1MeWeddingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1MeWeddings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1MeWeddingsQueryKey(options)
});

/**
 * Create an organization account
 *
 * Creates an organization; the caller becomes its first member automatically.
 */
export const postApiV1OrganizationsMutation = (options?: Partial<Options<PostApiV1OrganizationsData>>): UseMutationOptions<PostApiV1OrganizationsResponse, PostApiV1OrganizationsError, Options<PostApiV1OrganizationsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1OrganizationsResponse, PostApiV1OrganizationsError, Options<PostApiV1OrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Organizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1OrganizationsByOrganizationIdQueryKey = (options: Options<GetApiV1OrganizationsByOrganizationIdData>) => createQueryKey('getApiV1OrganizationsByOrganizationId', options);

/**
 * Get an organization's profile
 *
 * Requires the caller to be a member of this organization.
 */
export const getApiV1OrganizationsByOrganizationIdOptions = (options: Options<GetApiV1OrganizationsByOrganizationIdData>) => queryOptions<GetApiV1OrganizationsByOrganizationIdResponse, GetApiV1OrganizationsByOrganizationIdError, GetApiV1OrganizationsByOrganizationIdResponse, ReturnType<typeof getApiV1OrganizationsByOrganizationIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OrganizationsByOrganizationId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OrganizationsByOrganizationIdQueryKey(options)
});

export const getApiV1OrganizationsByOrganizationIdMembersQueryKey = (options: Options<GetApiV1OrganizationsByOrganizationIdMembersData>) => createQueryKey('getApiV1OrganizationsByOrganizationIdMembers', options);

/**
 * List an organization's members
 *
 * Phase-1 read-only member list — no invite/role-management endpoints yet. Requires the caller to be a member.
 */
export const getApiV1OrganizationsByOrganizationIdMembersOptions = (options: Options<GetApiV1OrganizationsByOrganizationIdMembersData>) => queryOptions<GetApiV1OrganizationsByOrganizationIdMembersResponse, GetApiV1OrganizationsByOrganizationIdMembersError, GetApiV1OrganizationsByOrganizationIdMembersResponse, ReturnType<typeof getApiV1OrganizationsByOrganizationIdMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OrganizationsByOrganizationIdMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OrganizationsByOrganizationIdMembersQueryKey(options)
});

export const getApiV1OrganizationsByOrganizationIdWeddingsQueryKey = (options: Options<GetApiV1OrganizationsByOrganizationIdWeddingsData>) => createQueryKey('getApiV1OrganizationsByOrganizationIdWeddings', options);

/**
 * List all weddings under an organization
 *
 * The organization dashboard's event list. Requires the caller to be a member — an IDOR target if membership weren't checked.
 */
export const getApiV1OrganizationsByOrganizationIdWeddingsOptions = (options: Options<GetApiV1OrganizationsByOrganizationIdWeddingsData>) => queryOptions<GetApiV1OrganizationsByOrganizationIdWeddingsResponse, GetApiV1OrganizationsByOrganizationIdWeddingsError, GetApiV1OrganizationsByOrganizationIdWeddingsResponse, ReturnType<typeof getApiV1OrganizationsByOrganizationIdWeddingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OrganizationsByOrganizationIdWeddings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OrganizationsByOrganizationIdWeddingsQueryKey(options)
});

export const getApiV1StaffInvitationsByTokenQueryKey = (options: Options<GetApiV1StaffInvitationsByTokenData>) => createQueryKey('getApiV1StaffInvitationsByToken', options);

/**
 * Preview a staff invitation by its raw token
 *
 * Unauthenticated: resolves the accept-link token so the landing page can show the invitee what they're accepting before they sign in. Every rejection reason (unknown/expired/revoked/consumed token) maps to the same generic 404 — this must not leak which.
 */
export const getApiV1StaffInvitationsByTokenOptions = (options: Options<GetApiV1StaffInvitationsByTokenData>) => queryOptions<GetApiV1StaffInvitationsByTokenResponse, GetApiV1StaffInvitationsByTokenError, GetApiV1StaffInvitationsByTokenResponse, ReturnType<typeof getApiV1StaffInvitationsByTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1StaffInvitationsByToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1StaffInvitationsByTokenQueryKey(options)
});

/**
 * Accept a staff invitation
 *
 * Grants the WeddingStaff row and consumes the invitation. Requires a Better Auth (service-verified) token whose `email` claim matches the invitation and whose `emailVerified` claim is true — a Firebase (LIFF guest) token is rejected outright, since it carries no meaningful email claim to compare against.
 */
export const postApiV1StaffInvitationsByTokenAcceptMutation = (options?: Partial<Options<PostApiV1StaffInvitationsByTokenAcceptData>>): UseMutationOptions<PostApiV1StaffInvitationsByTokenAcceptResponse, PostApiV1StaffInvitationsByTokenAcceptError, Options<PostApiV1StaffInvitationsByTokenAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1StaffInvitationsByTokenAcceptResponse, PostApiV1StaffInvitationsByTokenAcceptError, Options<PostApiV1StaffInvitationsByTokenAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1StaffInvitationsByTokenAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a wedding
 *
 * No existing wedding to check access against yet, so only identity is required. If organizationId is omitted, the caller's own organization is used (bootstrapped automatically if they have none yet) — see wedding.Service.CreateWedding. If organizationId is set, the caller must already be a member of that organization — otherwise anyone could create weddings under an organization just by supplying its ID.
 */
export const postApiV1WeddingsMutation = (options?: Partial<Options<PostApiV1WeddingsData>>): UseMutationOptions<PostApiV1WeddingsResponse, PostApiV1WeddingsError, Options<PostApiV1WeddingsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsResponse, PostApiV1WeddingsError, Options<PostApiV1WeddingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Weddings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdData>) => createQueryKey('getApiV1WeddingsByWeddingId', options);

/**
 * Get a wedding
 *
 * Requires proven access to this wedding (owner or member of its organizer) — already verified by the time this handler runs.
 */
export const getApiV1WeddingsByWeddingIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdResponse, GetApiV1WeddingsByWeddingIdError, GetApiV1WeddingsByWeddingIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdQueryKey(options)
});

/**
 * Submit an e-angpao transfer slip
 *
 * Multipart upload; the response includes a ready-to-use image URL (no client-side storage access needed).
 */
export const postApiV1WeddingsByWeddingIdActivitiesAngpaoMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdActivitiesAngpaoData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesAngpaoResponse, PostApiV1WeddingsByWeddingIdActivitiesAngpaoError, Options<PostApiV1WeddingsByWeddingIdActivitiesAngpaoData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesAngpaoResponse, PostApiV1WeddingsByWeddingIdActivitiesAngpaoError, Options<PostApiV1WeddingsByWeddingIdActivitiesAngpaoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdActivitiesAngpao({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdActivitiesBlessingsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>) => createQueryKey('getApiV1WeddingsByWeddingIdActivitiesBlessings', options);

/**
 * List blessings (newest first)
 *
 * Initial snapshot for the wall display; live updates arrive over the realtime channel.
 */
export const getApiV1WeddingsByWeddingIdActivitiesBlessingsOptions = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>) => queryOptions<GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, GetApiV1WeddingsByWeddingIdActivitiesBlessingsError, GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdActivitiesBlessingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdActivitiesBlessings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdActivitiesBlessingsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getApiV1WeddingsByWeddingIdActivitiesBlessingsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>> => createQueryKey('getApiV1WeddingsByWeddingIdActivitiesBlessings', options, true);

/**
 * List blessings (newest first)
 *
 * Initial snapshot for the wall display; live updates arrive over the realtime channel.
 */
export const getApiV1WeddingsByWeddingIdActivitiesBlessingsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, GetApiV1WeddingsByWeddingIdActivitiesBlessingsError, InfiniteData<GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdActivitiesBlessings({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdActivitiesBlessingsInfiniteQueryKey(options)
});

/**
 * Log a wedding blessing
 */
export const postApiV1WeddingsByWeddingIdActivitiesBlessingsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdActivitiesBlessingsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, PostApiV1WeddingsByWeddingIdActivitiesBlessingsError, Options<PostApiV1WeddingsByWeddingIdActivitiesBlessingsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesBlessingsResponse, PostApiV1WeddingsByWeddingIdActivitiesBlessingsError, Options<PostApiV1WeddingsByWeddingIdActivitiesBlessingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdActivitiesBlessings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Draw a random number (lucky draw)
 *
 * Server-side draw: honors the admin's forceNextWin/targetNumber, logs the attempt, and on a win atomically ends the game and archives the session — of two concurrent winning draws exactly one lands.
 */
export const postApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawResponse, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawError, Options<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawResponse, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawError, Options<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdActivitiesRandomNumberDraw({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdActivitiesRandomNumberStateQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateData>) => createQueryKey('getApiV1WeddingsByWeddingIdActivitiesRandomNumberState', options);

/**
 * Guest: get the random-number game state
 *
 * Guest-safe subset of the state (status, settings, winners, showQRCode) — targetNumber and forceNextWin are stripped, see toGuestSafeRandomNumberData.
 */
export const getApiV1WeddingsByWeddingIdActivitiesRandomNumberStateOptions = (options: Options<GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateData>) => queryOptions<GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateResponse, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateError, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdActivitiesRandomNumberStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdActivitiesRandomNumberState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdActivitiesRandomNumberStateQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesAngpao', options);

/**
 * Admin: list e-angpao submissions with resolved image URLs
 *
 * Replaces the frontend's realtime Firestore listener + client-side getDownloadURL.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoError, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesAngpao({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesAngpao', options, true);

/**
 * Admin: list e-angpao submissions with resolved image URLs
 *
 * Replaces the frontend's realtime Firestore listener + client-side getDownloadURL.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesAngpao({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesAngpaoInfiniteQueryKey(options)
});

/**
 * Admin: reset the random-number game
 */
export const postApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetError, Options<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetError, Options<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState', options);

/**
 * Admin: get the random-number game state
 *
 * Full state including targetNumber/forceNextWin (staff-only — never expose these to guests). Seeds the default state on first call.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateError, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateQueryKey(options)
});

/**
 * Admin: update the random-number game state
 *
 * Partial merge of {status, settings, targetNumber, forceNextWin, showQRCode, startedAt, winners} — replaces the admin UI's former direct RTDB writes.
 */
export const putApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateMutation = (options?: Partial<Options<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData>>): UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateError, Options<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponse, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateError, Options<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminActivitiesSessionsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesSessions', options);

/**
 * Admin: list archived game sessions (newest first)
 *
 * Replaces the frontend's direct Firestore activity_sessions query.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesSessionsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsError, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminActivitiesSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesSessionsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminActivitiesSessionsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesSessions', options, true);

/**
 * Admin: list archived game sessions (newest first)
 *
 * Replaces the frontend's direct Firestore activity_sessions query.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesSessionsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesSessions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesSessionsInfiniteQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminActivitiesWallQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesWallData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminActivitiesWall', options);

/**
 * Admin: get the wall state
 *
 * Seeds the default state (Thai default session) on first call, matching ok-wedding.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesWallOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesWallData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, GetApiV1WeddingsByWeddingIdAdminActivitiesWallError, GetApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminActivitiesWallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminActivitiesWall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminActivitiesWallQueryKey(options)
});

/**
 * Admin: update the wall state (partial merge)
 */
export const putApiV1WeddingsByWeddingIdAdminActivitiesWallMutation = (options?: Partial<Options<PutApiV1WeddingsByWeddingIdAdminActivitiesWallData>>): UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, PutApiV1WeddingsByWeddingIdAdminActivitiesWallError, Options<PutApiV1WeddingsByWeddingIdAdminActivitiesWallData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminActivitiesWallResponse, PutApiV1WeddingsByWeddingIdAdminActivitiesWallError, Options<PutApiV1WeddingsByWeddingIdAdminActivitiesWallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1WeddingsByWeddingIdAdminActivitiesWall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: upload a wall background image
 */
export const postApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundError, Options<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundResponse, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundError, Options<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminActivitiesWallBackground({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminCheckinsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminCheckins', options);

/**
 * Admin: list checked-in parties (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminCheckinsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminCheckinsResponse, GetApiV1WeddingsByWeddingIdAdminCheckinsError, GetApiV1WeddingsByWeddingIdAdminCheckinsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminCheckinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminCheckins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminCheckinsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminCheckinsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminCheckins', options, true);

/**
 * Admin: list checked-in parties (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminCheckinsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminCheckinsResponse, GetApiV1WeddingsByWeddingIdAdminCheckinsError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminCheckinsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminCheckins({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminCheckinsInfiniteQueryKey(options)
});

/**
 * Admin: manually check in a guest without LINE
 *
 * No attendee record is created and no LINE message is sent; the check-in window is ignored. Repeated manual check-ins keep incrementing the party's count.
 */
export const postApiV1WeddingsByWeddingIdAdminCheckinsManualMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminCheckinsManualData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminCheckinsManualResponse, PostApiV1WeddingsByWeddingIdAdminCheckinsManualError, Options<PostApiV1WeddingsByWeddingIdAdminCheckinsManualData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminCheckinsManualResponse, PostApiV1WeddingsByWeddingIdAdminCheckinsManualError, Options<PostApiV1WeddingsByWeddingIdAdminCheckinsManualData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminCheckinsManual({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: reset a party's check-in
 *
 * Reverts the guest to pending and deletes all its attendee records, atomically (transaction).
 */
export const deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: remove one LINE user from a party's check-in
 *
 * Deletes the attendee and decrements the party's checkedInCount (at 0 the party reverts to pending), atomically.
 */
export const deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminDisplayTokensQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminDisplayTokensData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminDisplayTokens', options);

/**
 * Admin: list display tokens
 *
 * Raw token values are never returned — only label, expiry and revocation state.
 */
export const getApiV1WeddingsByWeddingIdAdminDisplayTokensOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminDisplayTokensData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, GetApiV1WeddingsByWeddingIdAdminDisplayTokensError, GetApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminDisplayTokensQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminDisplayTokens({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminDisplayTokensQueryKey(options)
});

/**
 * Admin: mint a display token
 *
 * Returns the raw token exactly once — only its hash is stored, so it cannot be shown again. Staff paste it into the venue device's URL.
 */
export const postApiV1WeddingsByWeddingIdAdminDisplayTokensMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminDisplayTokensData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, PostApiV1WeddingsByWeddingIdAdminDisplayTokensError, Options<PostApiV1WeddingsByWeddingIdAdminDisplayTokensData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminDisplayTokensResponse, PostApiV1WeddingsByWeddingIdAdminDisplayTokensError, Options<PostApiV1WeddingsByWeddingIdAdminDisplayTokensData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminDisplayTokens({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: revoke a display token
 *
 * Kills the credential immediately — the answer to a venue URL that got shared, without waiting for expiry.
 */
export const deleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdResponse, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdResponse, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminGuestsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminGuests', options);

/**
 * Admin: list guests with full details
 *
 * Same filters as the guest-facing list, plus phone/notes/lineUserIds/preloadedUsers on each row.
 */
export const getApiV1WeddingsByWeddingIdAdminGuestsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminGuestsResponse, GetApiV1WeddingsByWeddingIdAdminGuestsError, GetApiV1WeddingsByWeddingIdAdminGuestsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminGuestsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminGuestsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminGuests', options, true);

/**
 * Admin: list guests with full details
 *
 * Same filters as the guest-facing list, plus phone/notes/lineUserIds/preloadedUsers on each row.
 */
export const getApiV1WeddingsByWeddingIdAdminGuestsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminGuestsResponse, GetApiV1WeddingsByWeddingIdAdminGuestsError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminGuestsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminGuests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminGuestsInfiniteQueryKey(options)
});

/**
 * Create a guest in the master list
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsResponse, PostApiV1WeddingsByWeddingIdAdminGuestsError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsResponse, PostApiV1WeddingsByWeddingIdAdminGuestsError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuests({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: batch create or update guest list
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBatchMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsBatchData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBatchResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBatchError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBatchData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBatchResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBatchError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk delete guests
 *
 * Cascades: attendees and table assignments of all deleted guests are removed.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk map LINE user IDs and metadata to guests
 *
 * Adds each lineUserId to its guest's party ($addToSet) with preloaded metadata; already-checked-in attendees get their metadata updated and rich menus re-evaluated.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsResponse, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import guests from CSV
 *
 * Multipart CSV upload, upserted by fullName. Columns: fullName, displayName, group, side, followers, lineUserId, maritalStatus, tableNumber. Rows with a tableNumber auto-create the table and assignment. Optional "mappings" form field: JSON {side: {raw: groom|bride}, maritalStatus: {raw: single|not_single|prefer_not_to_say}}.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsImportMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsImportData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsImportError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsImportData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsImportError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: parse uploaded guest list file (.csv or .xlsx)
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsParseImportMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportResponse, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsParseImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a guest
 *
 * Cascades: the party's attendees and table assignment are removed too.
 */
export const deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminGuestsByGuestIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminGuestsByGuestId', options);

/**
 * Admin: get one guest with checked-in users
 */
export const getApiV1WeddingsByWeddingIdAdminGuestsByGuestIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminGuestsByGuestIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminGuestsByGuestId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminGuestsByGuestIdQueryKey(options)
});

/**
 * Update guest details
 *
 * Partial update. Changing expectedFollowers syncs the assignment's seats; on checked-in guests, preloaded metadata propagates to attendees and their rich menus re-evaluate.
 */
export const patchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdMutation = (options?: Partial<Options<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>>): UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, Options<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponse, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdError, Options<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1WeddingsByWeddingIdAdminGuestsByGuestId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: acknowledge a public registration (create new or merge)
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: link a LINE account to a guest
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersResponse, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersError, Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: unlink a LINE account from a guest
 */
export const deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminLineChannelQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminLineChannelData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminLineChannel', options);

/**
 * Admin: get the wedding's LINE MINI App & Messaging API configuration
 *
 * Returns public IDs, masked secret boolean flags, expected LIFF endpoint URL, and timestamp. An unconfigured wedding returns an empty object, not a 404.
 */
export const getApiV1WeddingsByWeddingIdAdminLineChannelOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminLineChannelData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminLineChannelResponse, GetApiV1WeddingsByWeddingIdAdminLineChannelError, GetApiV1WeddingsByWeddingIdAdminLineChannelResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminLineChannelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminLineChannel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminLineChannelQueryKey(options)
});

/**
 * Admin: set the wedding's LINE MINI App & Messaging API configuration
 *
 * Partial update — omitted fields are left unchanged. Creates the row on first call.
 */
export const patchApiV1WeddingsByWeddingIdAdminLineChannelMutation = (options?: Partial<Options<PatchApiV1WeddingsByWeddingIdAdminLineChannelData>>): UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminLineChannelResponse, PatchApiV1WeddingsByWeddingIdAdminLineChannelError, Options<PatchApiV1WeddingsByWeddingIdAdminLineChannelData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminLineChannelResponse, PatchApiV1WeddingsByWeddingIdAdminLineChannelError, Options<PatchApiV1WeddingsByWeddingIdAdminLineChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1WeddingsByWeddingIdAdminLineChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: verify LINE Messaging API configuration
 *
 * Verifies Messaging Channel ID, Secret (via stateless token + bot info) and Access Token (bot info), ensuring both bot profiles match.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessaging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: verify LINE MINI App channel configuration
 *
 * Verifies LIFF app via LINE contextToken API, decoding JWT claims, checking channel ID prefix match, and verifying channel secret with OAuth2 stateless token API.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniapp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: create Same-Provider verification session
 *
 * Creates a 10-minute verification session storing unsaved messagingAccessToken and liffId, returning verifyToken.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionResponse, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionError, Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminLineChannelVerifySession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminLineUsersQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminLineUsersData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminLineUsers', options);

/**
 * Admin: list active LINE users for wedding
 */
export const getApiV1WeddingsByWeddingIdAdminLineUsersOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminLineUsersData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminLineUsersResponse, GetApiV1WeddingsByWeddingIdAdminLineUsersError, GetApiV1WeddingsByWeddingIdAdminLineUsersResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminLineUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminLineUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminLineUsersQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminRichmenusQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenus', options);

/**
 * Admin: list LINE rich menus
 *
 * Returns only Rich Menus created and stored by this platform for the wedding, including conditions, priority, and image metadata.
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusError, GetApiV1WeddingsByWeddingIdAdminRichmenusResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRichmenusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusQueryKey(options)
});

/**
 * Admin: create a LINE rich menu
 *
 * Registers the menu with LINE ("liff" area actions are compiled to line://app deep links) and stores it locally with the conditions/priority metadata. Upload an image afterwards — LINE requires one before the menu can be linked or set default.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: cancel the default LINE rich menu
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminRichmenusDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: unlink the personal rich menu from one LINE user
 *
 * The user falls back to the default rich menu. Unlinking a user with no personal menu succeeds.
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenusSets', options);

/**
 * Admin: list Rich Menu Set drafts
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, DefaultError, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRichmenusSetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenusSets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusSetsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenusSets', options, true);

/**
 * Admin: list Rich Menu Set drafts
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, DefaultError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenusSets({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusSetsInfiniteQueryKey(options)
});

/**
 * Admin: create a Rich Menu Set draft
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: delete Rich Menu Set
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DefaultError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DefaultError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId', options);

/**
 * Admin: get Rich Menu Set draft
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DefaultError, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdQueryKey(options)
});

/**
 * Admin: autosave Rich Menu Set draft
 */
export const patchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdMutation = (options?: Partial<Options<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>>): UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DefaultError, Options<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponse, DefaultError, Options<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: duplicate Rich Menu Set
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: upload a Rich Menu Set page image
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: publish Rich Menu Set
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: validate Rich Menu Set draft
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateResponse, DefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: re-evaluate conditional rich menus for all users
 *
 * Runs the condition rule engine for every known LINE user of the wedding (attendees + guests' mapped LINE accounts), linking the matching menu or unlinking to the default.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSyncAllMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusSyncAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserId', options);

/**
 * Admin: get the rich menu linked to one LINE user
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdError, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdQueryKey(options)
});

/**
 * Admin: delete a LINE rich menu
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRichmenusByMenuId', options);

/**
 * Admin: get one LINE rich menu
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdError, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRichmenusByMenuId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdQueryKey(options)
});

/**
 * Admin: set the default LINE rich menu
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: upload a rich menu background image
 *
 * Sets the image on LINE (JPEG/PNG, max 1MB, 2500x1686 or 2500x843) and mirrors it to object storage for admin preview.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: link a rich menu to one LINE user
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdResponse, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdError, Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminRsvpsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminRsvps', options);

/**
 * Admin: list RSVP responses (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminRsvpsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminRsvpsResponse, GetApiV1WeddingsByWeddingIdAdminRsvpsError, GetApiV1WeddingsByWeddingIdAdminRsvpsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminRsvpsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminRsvps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRsvpsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminRsvpsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminRsvps', options, true);

/**
 * Admin: list RSVP responses (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminRsvpsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminRsvpsResponse, GetApiV1WeddingsByWeddingIdAdminRsvpsError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminRsvpsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminRsvps({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminRsvpsInfiniteQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminSettingsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminSettingsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminSettings', options);

/**
 * Admin: get full wedding settings
 */
export const getApiV1WeddingsByWeddingIdAdminSettingsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminSettingsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminSettingsResponse, GetApiV1WeddingsByWeddingIdAdminSettingsError, GetApiV1WeddingsByWeddingIdAdminSettingsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminSettingsQueryKey(options)
});

/**
 * Admin: update wedding settings
 *
 * Shallow-merges the given top-level keys into the settings blob (ok-wedding's RTDB update() semantics).
 */
export const patchApiV1WeddingsByWeddingIdAdminSettingsMutation = (options?: Partial<Options<PatchApiV1WeddingsByWeddingIdAdminSettingsData>>): UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminSettingsResponse, PatchApiV1WeddingsByWeddingIdAdminSettingsError, Options<PatchApiV1WeddingsByWeddingIdAdminSettingsData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminSettingsResponse, PatchApiV1WeddingsByWeddingIdAdminSettingsError, Options<PatchApiV1WeddingsByWeddingIdAdminSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1WeddingsByWeddingIdAdminSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminStaffQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminStaffData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminStaff', options);

/**
 * List a wedding's staff grants
 *
 * Every WeddingStaff row for this wedding, enriched with the LINE profile when known. The wedding owner and organizer members have implicit unrestricted access and do not appear here.
 */
export const getApiV1WeddingsByWeddingIdAdminStaffOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminStaffData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminStaffResponse, GetApiV1WeddingsByWeddingIdAdminStaffError, GetApiV1WeddingsByWeddingIdAdminStaffResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminStaffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminStaff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminStaffQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminStaffInvitationsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminStaffInvitationsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminStaffInvitations', options);

/**
 * List a wedding's pending staff invitations
 *
 * Every still-acceptable (not expired/consumed/revoked) invitation for this wedding — no token or hash is ever included.
 */
export const getApiV1WeddingsByWeddingIdAdminStaffInvitationsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminStaffInvitationsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsError, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminStaffInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminStaffInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminStaffInvitationsQueryKey(options)
});

/**
 * Invite a staff member by email
 *
 * Mints an accept-link invitation and emails it to the invitee. Requires unrestricted admin access, same as staff management — the raw accept token is never returned in this response, only delivered via email.
 */
export const postApiV1WeddingsByWeddingIdAdminStaffInvitationsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsError, Options<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsResponse, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsError, Options<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminStaffInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke a pending staff invitation
 *
 * Invalidates the accept-link so the invitee can no longer use it.
 */
export const deleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke a staff member
 *
 * Deletes the WeddingStaff row — the user keeps guest access, loses all admin modules.
 */
export const deleteApiV1WeddingsByWeddingIdAdminStaffByUserIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminStaffByUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Grant or update a staff member
 *
 * Creates or replaces the WeddingStaff row for userId. Requires unrestricted admin access — module-scoped staff cannot manage staff (no self-escalation).
 */
export const putApiV1WeddingsByWeddingIdAdminStaffByUserIdMutation = (options?: Partial<Options<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData>>): UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdError, Options<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdResponse, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdError, Options<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1WeddingsByWeddingIdAdminStaffByUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign a guest party to a table
 *
 * Capacity-checked upsert (one assignment per party) with optional seat slots. Stamps the guest's denormalized tableNumber and seatDisplay, propagates to checked-in attendees, and notifies them via LINE.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesAssignMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesAssignData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesAssignResponse, PostApiV1WeddingsByWeddingIdAdminTablesAssignError, Options<PostApiV1WeddingsByWeddingIdAdminTablesAssignData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesAssignResponse, PostApiV1WeddingsByWeddingIdAdminTablesAssignError, Options<PostApiV1WeddingsByWeddingIdAdminTablesAssignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesAssign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAdminTablesAssignmentsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>) => createQueryKey('getApiV1WeddingsByWeddingIdAdminTablesAssignments', options);

/**
 * Admin: list all table assignments
 *
 * Paginated, sorted by tableNumber. Guests and tables are preloaded.
 */
export const getApiV1WeddingsByWeddingIdAdminTablesAssignmentsOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>) => queryOptions<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponse, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsError, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAdminTablesAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAdminTablesAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminTablesAssignmentsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdAdminTablesAssignmentsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>> => createQueryKey('getApiV1WeddingsByWeddingIdAdminTablesAssignments', options, true);

/**
 * Admin: list all table assignments
 *
 * Paginated, sorted by tableNumber. Guests and tables are preloaded.
 */
export const getApiV1WeddingsByWeddingIdAdminTablesAssignmentsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponse, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsError, InfiniteData<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdAdminTablesAssignments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAdminTablesAssignmentsInfiniteQueryKey(options)
});

/**
 * Assign multiple guest parties to one table
 *
 * With sync=true, parties currently on the table but absent from the list are unassigned first. Capacity checked once for the batch.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesBulkMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesBulkData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesBulkResponse, PostApiV1WeddingsByWeddingIdAdminTablesBulkError, Options<PostApiV1WeddingsByWeddingIdAdminTablesBulkData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesBulkResponse, PostApiV1WeddingsByWeddingIdAdminTablesBulkError, Options<PostApiV1WeddingsByWeddingIdAdminTablesBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a venue table / map point
 */
export const postApiV1WeddingsByWeddingIdAdminTablesMasterMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesMasterResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterError, Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesMasterResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterError, Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesMaster({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import venue tables from CSV
 *
 * Multipart CSV upload, upserted by tableNumber. Columns: tableNumber, capacity, notes, x, y, type, shape, width, height.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesMasterImportMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportError, Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportResponse, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportError, Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesMasterImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update venue tables / layout positions and dimensions
 */
export const putApiV1WeddingsByWeddingIdAdminTablesMasterLayoutMutation = (options?: Partial<Options<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData>>): UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutResponse, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutError, Options<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutResponse, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutError, Options<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1WeddingsByWeddingIdAdminTablesMasterLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a venue table
 */
export const deleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdMutation = (options?: Partial<Options<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>>): UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, Options<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a venue table / map point
 */
export const patchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdMutation = (options?: Partial<Options<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>>): UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, Options<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponse, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdError, Options<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiV1WeddingsByWeddingIdAdminTablesMasterByTableId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync all guest assignments and seat slots for a table
 *
 * Atomically synchronizes all assignments and specific seat slots on a table. Any guests previously assigned to this table but absent from the request are unassigned. Capacity and seat ranges are checked in a single transaction.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsError, Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsError, Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesSyncAssignments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recompute assignment seats from guests' expectedFollowers
 *
 * Drift repair for the denormalized seats field.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesSyncSeatsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsError, Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsResponse, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsError, Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesSyncSeats({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a guest party's table assignment
 */
export const postApiV1WeddingsByWeddingIdAdminTablesUnassignMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdAdminTablesUnassignData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesUnassignResponse, PostApiV1WeddingsByWeddingIdAdminTablesUnassignError, Options<PostApiV1WeddingsByWeddingIdAdminTablesUnassignData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdAdminTablesUnassignResponse, PostApiV1WeddingsByWeddingIdAdminTablesUnassignError, Options<PostApiV1WeddingsByWeddingIdAdminTablesUnassignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdAdminTablesUnassign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdAuthMeQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdAuthMeData>) => createQueryKey('getApiV1WeddingsByWeddingIdAuthMe', options);

/**
 * Get the caller's status and profile
 *
 * Check-in state, LINE profile, staff role/modules, current table (when checked in), and the preloaded guest party mapped to this LINE account (when not yet checked in — used for check-in prefill).
 */
export const getApiV1WeddingsByWeddingIdAuthMeOptions = (options: Options<GetApiV1WeddingsByWeddingIdAuthMeData>) => queryOptions<GetApiV1WeddingsByWeddingIdAuthMeResponse, GetApiV1WeddingsByWeddingIdAuthMeError, GetApiV1WeddingsByWeddingIdAuthMeResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdAuthMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdAuthMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdAuthMeQueryKey(options)
});

/**
 * Check in the authenticated LINE guest
 *
 * Resolves the caller's party (guestId → mapped LINE account → walk-in create), enforces the check-in window from settings, and guards against double check-in atomically. Sends the LINE success message afterwards.
 */
export const postApiV1WeddingsByWeddingIdCheckinsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdCheckinsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdCheckinsResponse, PostApiV1WeddingsByWeddingIdCheckinsError, Options<PostApiV1WeddingsByWeddingIdCheckinsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdCheckinsResponse, PostApiV1WeddingsByWeddingIdCheckinsError, Options<PostApiV1WeddingsByWeddingIdCheckinsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdCheckins({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberData>) => createQueryKey('getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumber', options);

/**
 * Display: lucky-draw random-number state
 */
export const getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberOptions = (options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberData>) => queryOptions<GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberResponse, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberError, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumber({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdDisplayActivitiesWallQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesWallData>) => createQueryKey('getApiV1WeddingsByWeddingIdDisplayActivitiesWall', options);

/**
 * Display: guest wall state
 *
 * Same state the backoffice drives, read by the projector. The winner clears itself once its deadline passes (docs/adr/0003) — the display never writes.
 */
export const getApiV1WeddingsByWeddingIdDisplayActivitiesWallOptions = (options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesWallData>) => queryOptions<GetApiV1WeddingsByWeddingIdDisplayActivitiesWallResponse, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallError, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdDisplayActivitiesWallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdDisplayActivitiesWall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdDisplayActivitiesWallQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdDisplayAttendeesQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdDisplayAttendeesData>) => createQueryKey('getApiV1WeddingsByWeddingIdDisplayAttendees', options);

/**
 * Display: every checked-in attendee
 *
 * Unpaged on purpose — the guest wall renders one bubble per attendee and rescales its layout past certain counts, so a page of them is the wrong shape. Authorized by a display token, not a user session.
 */
export const getApiV1WeddingsByWeddingIdDisplayAttendeesOptions = (options: Options<GetApiV1WeddingsByWeddingIdDisplayAttendeesData>) => queryOptions<GetApiV1WeddingsByWeddingIdDisplayAttendeesResponse, GetApiV1WeddingsByWeddingIdDisplayAttendeesError, GetApiV1WeddingsByWeddingIdDisplayAttendeesResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdDisplayAttendeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdDisplayAttendees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdDisplayAttendeesQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdDisplayGuestsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdDisplayGuestsData>) => createQueryKey('getApiV1WeddingsByWeddingIdDisplayGuests', options);

/**
 * Display: guest lookup for the kiosk
 *
 * Name search returning seat information only — a strict subset of the guest-facing list, since a kiosk is unattended hardware in a public lobby. Requires a search term and is not pageable: it looks one guest up, it does not enumerate the list.
 */
export const getApiV1WeddingsByWeddingIdDisplayGuestsOptions = (options: Options<GetApiV1WeddingsByWeddingIdDisplayGuestsData>) => queryOptions<GetApiV1WeddingsByWeddingIdDisplayGuestsResponse, GetApiV1WeddingsByWeddingIdDisplayGuestsError, GetApiV1WeddingsByWeddingIdDisplayGuestsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdDisplayGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdDisplayGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdDisplayGuestsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdGuestsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdGuestsData>) => createQueryKey('getApiV1WeddingsByWeddingIdGuests', options);

/**
 * List guests in the master list
 *
 * Filtered, paginated guest list. Filters: q (name substring), group, side, status, isTableAssigned; sortBy fullName|group|expectedFollowers|status|rsvpAt|checkedInAt|tableNumber|createdAt.
 */
export const getApiV1WeddingsByWeddingIdGuestsOptions = (options: Options<GetApiV1WeddingsByWeddingIdGuestsData>) => queryOptions<GetApiV1WeddingsByWeddingIdGuestsResponse, GetApiV1WeddingsByWeddingIdGuestsError, GetApiV1WeddingsByWeddingIdGuestsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdGuestsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdGuestsInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdGuestsData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdGuestsData>> => createQueryKey('getApiV1WeddingsByWeddingIdGuests', options, true);

/**
 * List guests in the master list
 *
 * Filtered, paginated guest list. Filters: q (name substring), group, side, status, isTableAssigned; sortBy fullName|group|expectedFollowers|status|rsvpAt|checkedInAt|tableNumber|createdAt.
 */
export const getApiV1WeddingsByWeddingIdGuestsInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdGuestsData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdGuestsResponse, GetApiV1WeddingsByWeddingIdGuestsError, InfiniteData<GetApiV1WeddingsByWeddingIdGuestsResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdGuestsData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdGuests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdGuestsInfiniteQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdGuestsGroupsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdGuestsGroupsData>) => createQueryKey('getApiV1WeddingsByWeddingIdGuestsGroups', options);

/**
 * Get all unique guest groups
 */
export const getApiV1WeddingsByWeddingIdGuestsGroupsOptions = (options: Options<GetApiV1WeddingsByWeddingIdGuestsGroupsData>) => queryOptions<GetApiV1WeddingsByWeddingIdGuestsGroupsResponse, GetApiV1WeddingsByWeddingIdGuestsGroupsError, GetApiV1WeddingsByWeddingIdGuestsGroupsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdGuestsGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdGuestsGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdGuestsGroupsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdGuestsByGuestIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdGuestsByGuestIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdGuestsByGuestId', options);

/**
 * Get one guest
 */
export const getApiV1WeddingsByWeddingIdGuestsByGuestIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdGuestsByGuestIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdGuestsByGuestIdResponse, GetApiV1WeddingsByWeddingIdGuestsByGuestIdError, GetApiV1WeddingsByWeddingIdGuestsByGuestIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdGuestsByGuestIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdGuestsByGuestId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdGuestsByGuestIdQueryKey(options)
});

/**
 * Ping Same-Provider verification from MINI App
 *
 * Validates verifyToken, extracts user ID from LINE access token, and queries LINE Messaging API to confirm user ID exists in the channel.
 */
export const postApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingResponse, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingError, Options<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingResponse, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingError, Options<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdLineChannelVerifyProviderPing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit an RSVP using an invitation token
 *
 * Unauthenticated by design — the invitation token IS the credential. Resubmitting overwrites the previous answer and keeps the original submittedAt.
 */
export const postApiV1WeddingsByWeddingIdRsvpsMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdRsvpsData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdRsvpsResponse, PostApiV1WeddingsByWeddingIdRsvpsError, Options<PostApiV1WeddingsByWeddingIdRsvpsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdRsvpsResponse, PostApiV1WeddingsByWeddingIdRsvpsError, Options<PostApiV1WeddingsByWeddingIdRsvpsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdRsvps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a public RSVP without an invitation token
 *
 * Unauthenticated — creates an unacknowledged EventGuest record with RegistrationSource: "public".
 */
export const postApiV1WeddingsByWeddingIdRsvpsPublicMutation = (options?: Partial<Options<PostApiV1WeddingsByWeddingIdRsvpsPublicData>>): UseMutationOptions<PostApiV1WeddingsByWeddingIdRsvpsPublicResponse, PostApiV1WeddingsByWeddingIdRsvpsPublicError, Options<PostApiV1WeddingsByWeddingIdRsvpsPublicData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1WeddingsByWeddingIdRsvpsPublicResponse, PostApiV1WeddingsByWeddingIdRsvpsPublicError, Options<PostApiV1WeddingsByWeddingIdRsvpsPublicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1WeddingsByWeddingIdRsvpsPublic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1WeddingsByWeddingIdRsvpsTokenInfoQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdRsvpsTokenInfoData>) => createQueryKey('getApiV1WeddingsByWeddingIdRsvpsTokenInfo', options);

/**
 * Get guest details by invitation token
 */
export const getApiV1WeddingsByWeddingIdRsvpsTokenInfoOptions = (options: Options<GetApiV1WeddingsByWeddingIdRsvpsTokenInfoData>) => queryOptions<GetApiV1WeddingsByWeddingIdRsvpsTokenInfoResponse, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoError, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdRsvpsTokenInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdRsvpsTokenInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdRsvpsTokenInfoQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdSettingsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdSettingsData>) => createQueryKey('getApiV1WeddingsByWeddingIdSettings', options);

/**
 * Get wedding settings (public)
 *
 * No auth — kiosk/signage displays read this before any login, matching ok-wedding's public GET /settings. LINE notification templates are stripped from the public payload.
 */
export const getApiV1WeddingsByWeddingIdSettingsOptions = (options: Options<GetApiV1WeddingsByWeddingIdSettingsData>) => queryOptions<GetApiV1WeddingsByWeddingIdSettingsResponse, GetApiV1WeddingsByWeddingIdSettingsError, GetApiV1WeddingsByWeddingIdSettingsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdSettingsQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentData>) => createQueryKey('getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignment', options);

/**
 * Get a guest party's table assignment
 *
 * Plain guests see null until the party has checked in (seat reveal at the event); staff always see it.
 */
export const getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentData>) => queryOptions<GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentResponse, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentError, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesMasterQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterData>) => createQueryKey('getApiV1WeddingsByWeddingIdTablesMaster', options);

/**
 * List venue tables with occupancy
 */
export const getApiV1WeddingsByWeddingIdTablesMasterOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterData>) => queryOptions<GetApiV1WeddingsByWeddingIdTablesMasterResponse, GetApiV1WeddingsByWeddingIdTablesMasterError, GetApiV1WeddingsByWeddingIdTablesMasterResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdTablesMasterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdTablesMaster({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesMasterQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesMasterInfiniteQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterData>): QueryKey<Options<GetApiV1WeddingsByWeddingIdTablesMasterData>> => createQueryKey('getApiV1WeddingsByWeddingIdTablesMaster', options, true);

/**
 * List venue tables with occupancy
 */
export const getApiV1WeddingsByWeddingIdTablesMasterInfiniteOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterData>) => infiniteQueryOptions<GetApiV1WeddingsByWeddingIdTablesMasterResponse, GetApiV1WeddingsByWeddingIdTablesMasterError, InfiniteData<GetApiV1WeddingsByWeddingIdTablesMasterResponse>, QueryKey<Options<GetApiV1WeddingsByWeddingIdTablesMasterData>>, number | Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdTablesMasterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1WeddingsByWeddingIdTablesMasterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiV1WeddingsByWeddingIdTablesMaster({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesMasterInfiniteQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesMasterAllQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterAllData>) => createQueryKey('getApiV1WeddingsByWeddingIdTablesMasterAll', options);

/**
 * List all venue tables (unpaginated, for the seating map)
 */
export const getApiV1WeddingsByWeddingIdTablesMasterAllOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterAllData>) => queryOptions<GetApiV1WeddingsByWeddingIdTablesMasterAllResponse, GetApiV1WeddingsByWeddingIdTablesMasterAllError, GetApiV1WeddingsByWeddingIdTablesMasterAllResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdTablesMasterAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdTablesMasterAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesMasterAllQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesMasterByTableIdQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdData>) => createQueryKey('getApiV1WeddingsByWeddingIdTablesMasterByTableId', options);

/**
 * Get one venue table
 */
export const getApiV1WeddingsByWeddingIdTablesMasterByTableIdOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdData>) => queryOptions<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdResponse, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdError, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdTablesMasterByTableIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdTablesMasterByTableId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesMasterByTableIdQueryKey(options)
});

export const getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsQueryKey = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsData>) => createQueryKey('getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuests', options);

/**
 * List guest parties assigned to a table
 */
export const getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsOptions = (options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsData>) => queryOptions<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsResponse, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsError, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsResponse, ReturnType<typeof getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsQueryKey(options)
});

export const getHealthzQueryKey = (options?: Options<GetHealthzData>) => createQueryKey('getHealthz', options);

/**
 * Health check
 *
 * Reports whether the API process is up. Does not check MongoDB connectivity.
 */
export const getHealthzOptions = (options?: Options<GetHealthzData>) => queryOptions<GetHealthzResponse, DefaultError, GetHealthzResponse, ReturnType<typeof getHealthzQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealthz({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthzQueryKey(options)
});

/**
 * Sync a membership accepted on the Better Auth side into this API
 *
 * Internal service-to-service endpoint (X-Internal-Secret, not a user bearer token). Called by wedding-tech-auth after an organization invitation is accepted, so the Go API's own authorization checks (which never read Better Auth's collections) recognize the new member. Not part of the public API surface — no Swagger @Security/@Tags.
 */
export const postInternalV1OrganizationsByOrganizationIdMembersMutation = (options?: Partial<Options<PostInternalV1OrganizationsByOrganizationIdMembersData>>): UseMutationOptions<unknown, PostInternalV1OrganizationsByOrganizationIdMembersError, Options<PostInternalV1OrganizationsByOrganizationIdMembersData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostInternalV1OrganizationsByOrganizationIdMembersError, Options<PostInternalV1OrganizationsByOrganizationIdMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInternalV1OrganizationsByOrganizationIdMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
